import React, { Component } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import DeleteUserFromGroupButton from './DeleteUserFromGroupButton';
import LoadingSpinner from './LoadingSpinner';

// To handle requests
import GroupsAPI from '../utils/GroupsAPI';

import './Modal.css';
import brandingStyles from '../branding/brandingStyles';
import { namespace } from '../../../config.json';

class ListUserGroupsButtonComponent extends Component {

    constructor() {
        super();
        this.state = {
            showModal: false,
            groups: null,
            dataLoaded: false,
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.refresh = this.refresh.bind(this);
    }

    // Open react-bootstrap modal
    openModal() {
        this.setState({ showModal: true });
        this.refresh();
    }

    // Close react-bootstrap modal
    closeModal() {
        this.setState({ showModal: false });
    }

    refresh() {
        // Launching list user groups
        GroupsAPI.listUserGroups(this.props.username).then(res => {
            this.setState({ groups: res.groups, dataLoaded: true });
        }).catch(message => {
            if (message.status === 401 || message.status === 403) {
                window.location.href =
                    `${namespace}/login/error/${message.status}`;
            }
        });
    }

    getGroupRow(group) {
        const iconStyle = {
            fontSize: '25px',
        };

        return (
            <li className="list-group-item clickable"
                key={ group.GroupId }
                style={Object.assign(
                  { borderRadius: '0px' },
                  brandingStyles.backgrounds.panelSecondary
                )}
            >
                <Link
                  to={`/users/groups/${group.GroupName}`}
                  style={brandingStyles.backgrounds.panelSecondary}
                >
                    <div className="pull-left" style={{ width: '70%' }}>
                      <i
                        className="fa fa-users pull-left margin-9"
                        style={
                          Object.assign(iconStyle, brandingStyles.mainColor)
                        }></i>
                      <strong>{ group.GroupName }</strong>
                      <br/>
                      <i>{ group.CreateDate }</i>
                    </div>
                </Link>
                <div className="pull-right">
                  <DeleteUserFromGroupButton
                    noSelectedLabel={true}
                    groupname={group.GroupName}
                    users={[this.props.username]}
                    callback={this.refresh}
                  />
                </div>
                <div className="clearfix"/>
              </li>
        );
    }

    render() {
        let groupsList;

        if (this.state.groups && this.state.groups.length) {
            const groupItems = this.state.groups.map(
              group => this.getGroupRow(group)
            );
            groupsList = <ul className="list-group">{groupItems}</ul>;
        } else {
            groupsList = <div className="alert alert-info">
                {this.props.username}
                &nbsp;does not belong to any group.
                You can add it to a group on the&nbsp;
                <Link to="/users/groups">Groups</Link>
                &nbsp;page.
            </div>;
        }

        return (
          <OverlayTrigger
            trigger={['hover', 'focus']}
            placement="top"
            overlay={
              <Tooltip id="userGroupsTooltip">
                User Groups
              </Tooltip>
          }>
            <button
              className="btn btn-primary btn-xs list-user-groups-btn"
              style={brandingStyles.buttons.primary}
              onClick={this.openModal}
            >
                <i className="fa fa-users"></i>

                <Modal show={this.state.showModal} onHide={this.closeModal}>
                    <Modal.Header
                      style={brandingStyles.backgrounds.panelHeader}
                    >
                        <Modal.Title
                          style={brandingStyles.backgrounds.panelHeader}
                        >
                            <i
                              className="fa fa-users"
                              style={brandingStyles.mainColor}
                            ></i>
                            <span>&nbsp;</span>
                            List {this.props.username}
                            <span>&nbsp;</span>
                            groups
                            <i
                                className="fa fa-times pull-right clickable"
                                style={Object.assign(
                                  { marginTop: '3px' },
                                  brandingStyles.mainColor
                                )}
                                onClick={this.closeModal}
                            ></i>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={brandingStyles.backgrounds.panel}>
                        <p>
                            <strong>{this.props.username}</strong>
                            &nbsp;belongs to the following groups :
                            <br/>
                            <i>Clicking on a group will display its details.</i>
                        </p>
                        {this.state.dataLoaded
                          ? groupsList : <LoadingSpinner />}
                    </Modal.Body>
                </Modal>
            </button>
          </OverlayTrigger>
        );
    }

}

// Username is mandatory for delete operation to work
ListUserGroupsButtonComponent.propTypes = {
    username: PropTypes.string.isRequired,
};

export default ListUserGroupsButtonComponent;



/** WEBPACK FOOTER **
 ** ./src/components/ListUserGroupsButton.js
 **/